import React, { useEffect } from 'react';
import {
	HashRouter as Router,
	Route,
	Routes,
} from "react-router-dom";
import "../externallibs/assets/vendor/nucleo/css/nucleo.css";
import '../externallibs/assets/scss/argon-design-system-react.scss'
import AppLoader from './businesslogic/loaders/apploader/AppLoader';
import DataLoader from './businesslogic/loaders/dataloader/DataLoader';
import Authentication from './businesslogic/authentication/Authentication';
import Dashboard from './businesslogic/dashboard/Dashboard';
import SignIn from './businesslogic/preloginscreens/signin/SignIn';
import SignUp from './businesslogic/preloginscreens/signup/SignUp';
import ForgotPassword from './businesslogic/preloginscreens/forgotpassword/ForgotPassword';
import SetPassword from './businesslogic/preloginscreens/forgotpassword/SetPassword';
import MemberAcceptInvitation from './businesslogic/preloginscreens/memberacceptinvitation/MemberAcceptInvitation';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Config from '../web/config.web.js'
import AppSwitch from './businesslogic/appswitch/AppSwitch';
import { INTEGRATION_ROUTES } from './businesslogic/constants/constants.js';
import SSOIntegrations from './businesslogic/ssointegrations/SSOIntegrations.js';

function Home() {

	useEffect(() => {
		if (typeof window !== 'undefined' && window.location) {
			let pathName = window.location.pathname;
			let newUrl = window.location.href;
			let shouldRedirect = false;

			if (!window.location.hash.includes('#/')) {
				newUrl = `#${pathName}${window.location.search}`;
				shouldRedirect = true;
			}
			if (newUrl.includes(INTEGRATION_ROUTES.CALLBACK_URL_INDEX_KEYWORD)) {
				newUrl = newUrl.replace(INTEGRATION_ROUTES.CALLBACK_URL_INDEX_KEYWORD, "");
				shouldRedirect = true;
			}
			if (newUrl.includes(INTEGRATION_ROUTES.CALLBACK_URL_INDEX2_KEYWORD)) {
				newUrl = newUrl.replace(INTEGRATION_ROUTES.CALLBACK_URL_INDEX2_KEYWORD, "");
				shouldRedirect = true;
			}
			if (shouldRedirect) {
				window.location.href = newUrl;
			}
		}
	}, []);

	const tax1099App = (
		<Routes>
			<Route path="*" element={
				<Dashboard />
			} />
			<Route path="/signin" element={
				<GoogleReCaptchaProvider reCaptchaKey={Config.CAPTCHA_SITE_KEY} >
					<SignIn />
				</GoogleReCaptchaProvider>
			} />
			<Route path="/signup" element={
				<GoogleReCaptchaProvider reCaptchaKey={Config.CAPTCHA_SITE_KEY} >
					<SignUp />
				</GoogleReCaptchaProvider>
			} />
			<Route path="/forgotpassword" element={
				<GoogleReCaptchaProvider reCaptchaKey={Config.CAPTCHA_SITE_KEY} >
					<ForgotPassword />
				</GoogleReCaptchaProvider>
			} />
			<Route path="/setpassword" element={
				<GoogleReCaptchaProvider reCaptchaKey={Config.CAPTCHA_SITE_KEY} >
					<SetPassword />
				</GoogleReCaptchaProvider>
			} />
			<Route path="/acceptinvitation" element={
				<GoogleReCaptchaProvider reCaptchaKey={Config.CAPTCHA_SITE_KEY} >
					<MemberAcceptInvitation />
				</GoogleReCaptchaProvider>
			} />
		</Routes>
	);

	return (
		<React.Suspense fallback="Loading...">
			<AppLoader>
				<Router>
					<Routes>
						<Route path="*" element={
							<AppSwitch>
								<SSOIntegrations>
									<Authentication>
										<DataLoader>
											{tax1099App}
										</DataLoader>
									</Authentication>
								</SSOIntegrations>
							</AppSwitch>
						} />
					</Routes>
				</Router>
			</AppLoader>
		</React.Suspense>
	)

}

export default Home;